import React, { useState } from "react";

const Tabs = ({ children }) => {
    const [activeTab, setActiveTab] = useState(children[0].props.label);

    const handleClick = (e, newActiveTab) => {
        e.preventDefault();
        setActiveTab(newActiveTab);
    };

    return (
        <div className="flex flex-col">
            <div className="border-b border-gray-200 dark:border-gray-700">
                <ul class="flex flex-wrap -mb-px text-sm font-medium text-center" id="default-tab" data-tabs-toggle="#default-tab-content" role="tablist">
                    {children.map((child) => (
                        <li class="me-4" role="presentation">
                            <button
                                key={child.props.label}
                                className={`inline-block p-6 border-b-1 rounded-t-lg  ${activeTab === child.props.label
                                        ? "text-gray-700 border-b-2 border-purple-500"
                                        : "text-gray-300 hover:text-gray-500"
                                    } flex-1 font-medium py-4`}
                                onClick={(e) => handleClick(e, child.props.label)}
                            >
                                {child.props.label}
                            </button></li>
                    ))}
                </ul>
            </div>
            <div className="">
                {children.map((child) => {
                    if (child.props.label === activeTab) {
                        return <div key={child.props.label}>{child.props.children}</div>;
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

const Tab = ({ label, children }) => {
    return (
        <div label={label} className="hidden">
            {children}
        </div>
    );
};
export { Tabs, Tab };